export default __webpack_public_path__ + "static/media/kit_labellisation_or.55366176.pdf";